export default __webpack_public_path__ + "static/media/01.2c1d8a0c.jpg";